var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9925 0H4.00833C1.475 0 0 1.335 0 3.6225V11.37C0 13.695 1.475 15 4.00833 15H10.9925C13.5667 15 15 13.695 15 11.37V3.6225C15 1.335 13.5667 0 10.9925 0Z",
    fill: "#212B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2335 3.4873V3.4948C3.87433 3.4948 3.5835 3.7573 3.5835 4.0798C3.5835 4.4023 3.87433 4.6648 4.2335 4.6648H6.72433C7.0835 4.6648 7.37516 4.4023 7.37516 4.07155C7.37516 3.7498 7.0835 3.4873 6.72433 3.4873H4.2335ZM10.7668 8.05415H4.2335C3.87433 8.05415 3.5835 7.79165 3.5835 7.46915C3.5835 7.14665 3.87433 6.8834 4.2335 6.8834H10.7668C11.1252 6.8834 11.4168 7.14665 11.4168 7.46915C11.4168 7.79165 11.1252 8.05415 10.7668 8.05415ZM10.7666 11.4823H4.2333C3.9833 11.5123 3.74163 11.3998 3.6083 11.2123C3.47497 11.0173 3.47497 10.7698 3.6083 10.5823C3.74163 10.3873 3.9833 10.2823 4.2333 10.3048H10.7666C11.0991 10.3348 11.35 10.5898 11.35 10.8973C11.35 11.1965 11.0991 11.4523 10.7666 11.4823Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon04);
export default __webpack_public_path__ + "static/media/menu-icon-04.02000b8de99d3f4f8c23a97a7cfdf912.svg";
export { ForwardRef as ReactComponent };